import { Component, Inject, OnInit, Optional } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TenantService } from '@core/tenant/tenant.service';
import { SeoService } from '@targx/services/seo/seo.service';

@Component({
  selector: 'ade-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  constructor(
    private _tenantService: TenantService,
    private _seoService: SeoService,
    @Optional() @Inject(DOCUMENT) private _document: Document,
  ) {}

  ngOnInit(): void {
    this._tenantService.profile$.subscribe((profile) => {
      const ds = profile?.dealerSite;
      if (!ds) return;

      this._seoService.handleSeoFromApi({
        metaTitle: ds.metaInfo?.metaTitle ?? profile.brandName ?? profile.name,
        metaDescription: ds.metaInfo?.metaDescription,
      });

      if (this._document) {
        const logoUrl = ds.branding?.logo?.url;
        if (logoUrl) {
          const splashImg = this._document.querySelector<HTMLImageElement>(
            'fuse-splash-screen img',
          );
          if (splashImg) {
            splashImg.src = logoUrl;
            splashImg.alt = profile.brandName ?? profile.name ?? '';
          }
        }
      }
    });
  }
}
